import {
  Box,
  Heading,
  LocalizedString,
  NumberedList,
  Stack,
} from "@dbn/omnichannel-design-system-g4p";
import { NonEmptyArray } from "fp-ts/NonEmptyArray";
import { useFormatMessage } from "../intl";
import { SmartKeyMode, SmartKeyVariant } from "./SmartKeyState";
import { MobileInvestmentsIcon } from "@g4p/react-styleguide-library";

type Props = { mode: SmartKeyMode; variant: SmartKeyVariant };

export function Left(props: Props) {
  const formatMessage = useFormatMessage();
  const titleMessage = ((): LocalizedString => {
    switch (props.variant) {
      case "authorization":
        return formatMessage("SmartKey.title.authorization");
      case "authentication":
        return formatMessage("SmartKey.title.authentication");
    }
  })();

  const instructions: NonEmptyArray<LocalizedString> =
    props.mode === "push"
      ? [
          formatMessage("SmartKey.authorization.firstInstruction"),
          formatMessage(
            "SmartKey.authorization.pushNotificaiton.secondInstruction"
          ),
          formatMessage(
            "SmartKey.authorization.pushNotificaiton.thirdInstruction"
          ),
        ]
      : [
          formatMessage("SmartKey.authorization.firstInstruction"),
          formatMessage("SmartKey.authorization.qrCode.secondInstruction"),
          formatMessage("SmartKey.authorization.qrCode.thirdInstruction"),
          formatMessage("SmartKey.authorization.qrCode.fourthInstruction"),
        ];

  return (
    <Stack units={8} column shrink>
      <Stack units={6} vAlignContent="center" hAlignContent="left" shrink>
        <MobileInvestmentsIcon
          width="24px"
          height="24px"
          style={{ marginLeft: "4px", marginRight: 0 }}
        />
        <Heading size="small" weight="bold">
          {titleMessage}
        </Heading>
      </Stack>
      <Box shrink>
        <NumberedList items={instructions} />
      </Box>
    </Stack>
  );
}
